import React from 'react';
import { useQuery } from '@apollo/client';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { SubscriptionTab, fetchSubscriptionsForInvoiceGroup } from '@css-xp/base/common-tabs';
import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';

interface SubscriptionTabIgProps {
  setBillDateSidebar: string;
  invoiceGroupId?: string;
  label?: string;
}

export const SubscriptionTabIg = ({ invoiceGroupId, label, setBillDateSidebar }: SubscriptionTabIgProps) => {
  const { data, loading, error, refetch } = useQuery<
    generatedTypesNew.FetchSubscriptionsForInvoiceGroupQuery,
    generatedTypesNew.FetchSubscriptionsForInvoiceGroupQueryVariables
  >(fetchSubscriptionsForInvoiceGroup, {
    variables: {
      id: invoiceGroupId ?? '',
      searchOptions: { first: DEFAULT_ROWS_PER_PAGE },
    },
    skip: !invoiceGroupId,
    nextFetchPolicy: 'cache-and-network',
  });

  const nodes = data?.invoiceGroup?.productSubscriptions?.nodes;
  const totalCount = data?.invoiceGroup?.productSubscriptions?.totalCount ?? 0;

  return (
    <SubscriptionTab
      nodes={nodes}
      totalRecords={totalCount}
      loading={loading}
      error={error}
      refetch={refetch}
      label={label}
      setBillDateSidebar={setBillDateSidebar}
      invoiceGroupId={invoiceGroupId}
    />
  );
};
